<template>
  <div
    id="call_campaign_banner"
    class="flex flex-col w-full proxima_nova text-white"
  >
    <div
      id="call_campaign_banner_components"
      class="flex flex-row items-center justify-between"
    >
      <BannerLeftSection />
      <BannerRightSection />
    </div>

    <div id="call_campaign_banner_actions">
      <CustomModal
        title="Pause Call Campaign?"
        v-model:visible="showPauseCampaign"
        :width="'32vw'"
      >
        <div class="flex flex-col gap-4">
          <span>Closing the Nav bar will pause the Call Campaign.</span>
          <span
            >Tip: You can resume the campaign later in the Call Campaigns menu.
            Ongoing calls will not be disconnected.</span
          >
        </div>
        <template #footer>
          <div class="flex flex-row gap-2 items-center justify-end">
            <a-button class="secondary_medium" @click="handleCloseModal"
              >Cancel</a-button
            >
            <a-button class="primary_medium" @click="handlePauseCampaign"
              >Pause Campaign</a-button
            >
          </div>
        </template>
      </CustomModal>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useStore } from "vuex";
import eventBus from "@/src/utils/eventBus.js";
import BannerLeftSection from "@/src/views/calls/call_campaigns/campaign_banner/BannerLeftSection.vue";
import BannerRightSection from "@/src/views/calls/call_campaigns/campaign_banner/BannerRightSection.vue";
import CustomModal from "@/src/components/CustomModal.vue";
import { callCampaignStatuses } from "@/src/constants/callConstants.js";
import { toUpdateCallCampaign } from "@/src/utils/callsUtils.js";

const store = useStore();
const showPauseCampaign = ref(false);

const campaignId = computed(
  () => store.getters["callsCampaign/currentCampaignId"],
);
const campaignDetails = computed(
  () => store.getters["callsCampaign/campaignDetails"],
);

const handleCloseModal = () => {
  showPauseCampaign.value = false;
};

const handleBannerClose = () => {
  try {
    showPauseCampaign.value = true;
  } catch (error) {
    console.error("An error occurred while handling banner close: ", error);
  }
};

const handlePauseCampaign = async () => {
  try {
    const payload = {
      status: callCampaignStatuses.PAUSED,
    };
    await toUpdateCallCampaign(campaignId.value, payload);
    store.dispatch("dynamicBanner/updateShowBanner", false);
    showPauseCampaign.value = false;
  } catch (error) {
    console.error("An error occurred while handling pause campaign", error);
  }
};

onMounted(() => {
  eventBus.on("banner-close", handleBannerClose);
});

onUnmounted(() => {
  eventBus.off("banner-close", handleBannerClose);
});
</script>
